import "./BrandWordmark.css";

export default function BrandIcon({ className = "" }: { className?: string }) {
  return (
    <img
      className={`brand-icon ${className}`}
      src="/icons/kexu-v3.svg"
      width={128}
      height={128}
      alt=""
      aria-hidden="true"
    />
  );
}
